require('./authorizationsTableRow.scss');
import PropTypes from 'prop-types';
// @ vendor
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { i18n } from 'core/i18n';
const { formatText, getLanguage } = i18n;
// @ commons
import ActionsTableCell from 'components/commons/actionsTableCell/actionsTableCell';
import OKTag from 'components/commons/OKTag/OKTag';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';
// @ components
import { LabelDate } from 'commonsComponents/labelDate';
// @ actions
import { setScroll } from 'actions/accountDebits';
import  { changeTab } from 'actions/accountDebits';
import { receiptsFilterByName } from 'actions/accountDebits/receipts';
import { initSelectFilter } from 'actions/filters';
// @ helpers
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';
import { OKCollapsingToggler } from 'commonsComponents/OKCollapsingToggler';
// @ constants
import {
    AUTHORIZATION_ACTIVE,
    AUTHORIZATION_CANCELED
} from 'constants/index';

class AuthorizationsTableRow extends React.Component {

    componentDidUpdate(){
        const { immAccountDebits, immAuthorizations, id, setScroll } = this.props;
        if (immAccountDebits.get('doScroll') && immAuthorizations.get('expandedRowId') === id) {
            this.cell.parentElement.scrollIntoView()
            setScroll(false);
        }
    }

    onRowClick = () => {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    handleShowReceipts = () => {
        const {
            changeTab,
            immTransaction,
            receiptsFilterByName,
            initSelectFilter
        } = this.props;
        const name = immTransaction.get('nombreActuante');
        const accountId = immTransaction.get('accountId');
        changeTab(0);
        receiptsFilterByName(accountId, name);
        initSelectFilter('receipts', 'name', true, name, 'todas', 'selectorFilter', name, name);
    }

    renderDateCell = (dates) => {
        if (dates.size) {
            return (
                <LabelDate
                    date={dates.getIn([0, 'fecvenci'])}
                    language={getLanguage()}
                    today={LABEL_DATE_TODAY}
                    yesterday={LABEL_DATE_YESTERDAY}
                />
            )
        } else {
            return ('-')
        }
    }

    renderOptions = (accountId, immTransaction) => {
        const receiptsIds = immTransaction.get('receiptsIds');
        const status = immTransaction.get('status');
        const authorizationId = immTransaction.get('id');

        return [
            ...(receiptsIds.size ? [{
                handleClick: this.handleShowReceipts,
                text: formatText('authorizations-showReceipts')
            }] : []),
            ...(status == AUTHORIZATION_ACTIVE && receiptsIds.size ? [{
                link: `/myprofile/accounts/${accountId}/debits/annulationPayments/${receiptsIds.get(0)}`,
                text: formatText('accountDebitAnnulation-cancel')
            }] : []),
            ...(status == AUTHORIZATION_CANCELED && receiptsIds.size ? [{
                link: `/myprofile/accounts/${accountId}/debits/activationPayments/${authorizationId}`,
                text: formatText('authorizationActivation-activate')
            }] : []),
            ...[{
                link: `/myprofile/accounts/${accountId}/debits/authorizationModifyAccount/${authorizationId}`,
                text: formatText('authorization-modifyAccount')
            }]
        ]
    }

    render() {
        const {
            immTransaction,
            id,
            isExpanded
        } = this.props;
        const accountId = immTransaction.get('accountId');
        const status = immTransaction.get('status');
        const nameClass = classNames('authorizations-table-row__name', {
            'authorizations-table-row__name--highlighted': isExpanded
        });
        const tagContent = `common-${status}`;
        return (
            <OKTableRow id={id} isExpanded={isExpanded} >
                <OKTableCell className="authorizations-table-row__expand-button">
                    <span ref={(el) => { this.cell = el; }}>
                        <OKCollapsingToggler handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={true} />
                    </span>
                </OKTableCell>
                <OKTableCell className={nameClass}>
                    {immTransaction.get('nombreActuante')}
                </OKTableCell>
                <OKTableCell className="authorizations-table-row__date" >
                    { this.renderDateCell(immTransaction.getIn(['listaRecibos', 'recibos'])) }
                </OKTableCell>
                <OKTableCell className="authorizations-table-row__status">
                    <OKTag
                        content={tagContent}
                        context="arrow"
                    />
                </OKTableCell>
                <OKTableCell className="authorizations-table-row__actions">
                    <ActionsTableCell
                        options={this.renderOptions(accountId, immTransaction)}
                        translationKey={'manageDevices-options'}
                    />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

AuthorizationsTableRow.propTypes = {
    id: PropTypes.string.isRequired,
    immAccountDebits: PropTypes.object.isRequired,
    immAuthorizations: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    isExpandable: PropTypes.bool,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
    setScroll: PropTypes.func,
    changeTab: PropTypes.func,
    receiptsFilterByName: PropTypes.func,
    initSelectFilter: PropTypes.func
};

AuthorizationsTableRow.defaultProps = {
    onRowClick: () => { }
};

export default connect(
    (state, ownProps) => {
        return {
            immAccountDebits: state.accountDebits,
            immAuthorizations: state.authorizations.get(ownProps.immTransaction.get('accountId'))
        }
    },
    {
        setScroll,
        changeTab,
        receiptsFilterByName,
        initSelectFilter,
    }
)(AuthorizationsTableRow);
